import React from "react";


function EpflLogo() {
  return (
      <div>
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="140"
        height="53"
        data-name="logo epfl 2019"
        viewBox="0 0 182.4 53">
            <path
                d="M0 21.6L11.43 21.6 11.43 9.8 38.34 9.8 38.34 0 0 0 0 21.6z"
                style={{fill:"#ff0000"}}></path>
            <path
                d="M0 53L38.34 53 38.34 43.2 11.43 43.2 11.43 31.4 0 31.4 0 53z"
                style={{fill:"#ff0000"}}></path>
            <path
                d="M11.43 21.6H36.04V31.400000000000002H11.43z"
                style={{fill:"#ff0000"}}></path>
            <path
                d="M86 4.87a16.12 16.12 0 00-5.68-3.53A23.76 23.76 0 0071.82 0H48.14v53h11.43V31.4h12.25a23.76 23.76 0 008.46-1.34A16.12 16.12 0 0086 26.53a13.43 13.43 0 003.19-5 17.38 17.38 0 000-11.62A13.52 13.52 0 0086 4.87zm-8 13.86a5.7 5.7 0 01-2.26 1.8 11.33 11.33 0 01-3.27.85 32 32 0 01-3.86.22h-9.04V9.8h9.05a32 32 0 013.86.22 11 11 0 013.27.86A5.59 5.59 0 0178 12.67a5 5 0 01.86 3 5 5 0 01-.86 3.06z"
                style={{fill:"#ff0000"}}></path>
            <path
                d="M155.47 43.2L155.47 0 144.04 0 144.04 53 182.38 53 182.38 43.2 155.47 43.2z"
                style={{fill:"#ff0000"}}></path>
            <path
                d="M97.42 21.6L108.85 21.6 108.85 9.8 135.76 9.8 135.76 0 97.42 0 97.42 21.6z"
                style={{fill:"#ff0000"}}></path>
            <path 
                d="M97.42 31.4H108.85V53H97.42z" 
                style={{fill:"#ff0000"}}></path>
            <path 
                d="M108.85 21.6H133.45999999999998V31.400000000000002H108.85z"
                style={{fill:"#ff0000"}}></path>
        </svg>
    </div>
  );
}


export default EpflLogo;